import { render, staticRenderFns } from "./RestaurantProfileView.vue?vue&type=template&id=154cf4af&"
import script from "./RestaurantProfileView.vue?vue&type=script&lang=ts&"
export * from "./RestaurantProfileView.vue?vue&type=script&lang=ts&"
import style0 from "./RestaurantProfileView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports